<template>
  <el-dialog title="修改店铺" :visible.sync="dialogVisible" width="70%" @close="refreshEditShopInfo">
    <el-form :model="editShopInfo" label-width="120px" ref="editShopForm">
      <el-alert v-if="editShopInfo.state == '004'" type="warning" :closable="false" show-icon
        title="当前店铺未缴纳保证金，请先缴纳保证金后再修改店铺信息。" style="margin-bottom: 15px;"></el-alert>

      <el-form-item label="商铺名称" prop="shopName" required>
        <el-input v-model="editShopInfo.shopName" placeholder="必填，请填写商铺名称"></el-input>
      </el-form-item>

      <el-form-item label="商铺logo" prop="shopLogo" required>
        <upload-image-url ref="uploadImage" :imageCount="1"
          @notifyUploadCoverImage="handleUploadImage"></upload-image-url>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('shop.businessLicense')" prop="businessLicense" required>
            <file-upload v-model="editShopInfo.businessLicense" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('shop.foodLicense')" prop="foodLicense">
            <file-upload v-model="editShopInfo.foodLicense" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('shop.idCardFront')" prop="idCardFront" required>
            <file-upload v-model="editShopInfo.idCardFront" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('shop.idCardBack')" prop="idCardBack" required>
            <file-upload v-model="editShopInfo.idCardBack" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="商铺类型" prop="shopType" required>
            <el-select v-model="editShopInfo.shopType" placeholder="必填，请选择商铺类型" @change="_changeEditShopType"
              style="width:100%">
              <el-option v-for="item in shopInfo.shopTypes" :key="item.shopTypeId" :label="item.typeName"
                :value="item.shopTypeId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开店类型" prop="openType" required>
            <el-select v-model="editShopInfo.openType" placeholder="必填，请选择开店类型" style="width:100%">
              <el-option v-for="item in editShopInfo.openTypes" :key="item.statusCd" :label="item.name"
                :value="item.statusCd"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="商铺描述" prop="shopDesc" required>
        <el-input type="textarea" v-model="editShopInfo.shopDesc" placeholder="必填，请填写商铺描述"></el-input>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="售后联系人" prop="returnPerson" required>
            <el-input v-model="editShopInfo.returnPerson" placeholder="必填，请填写售后联系人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="returnLink" required>
            <el-input v-model="editShopInfo.returnLink" placeholder="必填，请填写联系电话"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="店铺地址" prop="sendAddress" required>
            <el-input type="textarea" v-model="editShopInfo.sendAddress" placeholder="必填，请填写店铺地址"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="售后退货地址" prop="returnAddress" required>
            <el-input type="textarea" v-model="editShopInfo.returnAddress" placeholder="必填，请填写售后退货地址"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('shop.coordinatesX')" prop="mapX">
            <el-input v-model="editShopInfo.mapX" :placeholder="$t('shop.getCoordinates')" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('shop.coordinatesY')" prop="mapY">
            <el-input v-model="editShopInfo.mapY" :placeholder="$t('shop.getCoordinates')" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="选择定位">
        <select-map-pos ref="selectMapPos" @position-change="handlePositionChange"></select-map-pos>
      </el-form-item>

      <el-form-item v-if="editShopInfo.state == '002'" label="修改原因" prop="applyOpinion" required>
        <el-input type="textarea" v-model="editShopInfo.applyOpinion" placeholder="必填，请填写修改原因"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" :disabled="editShopInfo.state == '004'" @click="editShop">保存</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { updateShop, getShopTypes } from '@/api/shop/shopApi'
import { getDict } from '@/api/shop/shopApi'
import UploadImageUrl from '@/components/system/UploadImageUrl'
import SelectMapPos from '@/components/system/selectMapPos'
import FileUpload from '@/components/system/FileUpload'

export default {
  components: {
    UploadImageUrl,
    SelectMapPos,
    FileUpload
  },
  data() {
    return {
      dialogVisible: false,
      editShopInfo: {
        shopId: '',
        shopName: '',
        shopLogo: '2',
        shopType: '',
        openType: '',
        shopDesc: '',
        changeLogo: "",
        sendAddress: '',
        storeId: '',
        returnPerson: '',
        returnLink: '',
        returnAddress: '',
        shopRange: '',
        shopRangeSel: [],
        shopRanges: [],
        openTypes: [],
        applyOpinion: '',
        mapX: '',
        mapY: '',
        state: '',
        areaCode: '',
        businessLicense: '',
        foodLicense: '',
        idCardFront: '',
        idCardBack: ''
      },
      shopInfo: {
        shopTypes: []
      },
      map: null
    }
  },
  methods: {
    open(shop) {
      this.dialogVisible = true
      this.$nextTick(async () => {
        this.refreshEditShopInfo()
        this._getShopTypes()
        await this.getDictData()
        Object.assign(this.editShopInfo, shop)
        this.editShopInfo.businessLicense = this.editShopInfo.businessLicense || ''
        this.editShopInfo.foodLicense = this.editShopInfo.foodLicense || ''
        this.editShopInfo.idCardFront = this.editShopInfo.idCardFront || ''
        this.editShopInfo.idCardBack = this.editShopInfo.idCardBack || ''
        this.$refs.uploadImage.setImages([shop.shopLogo])

        // 优先使用店铺已有坐标定位地图，没有坐标则使用默认位置
        const mapX = shop.mapX
        const mapY = shop.mapY
        if (mapX && mapY) {
          this.$refs.selectMapPos.initMap({ lng: mapX, lat: mapY })
        } else {
          this.$refs.selectMapPos.initMap({})
        }
      })
    },
    async getDictData() {
      try {
        const { data } = await getDict('s_shop', 'open_type')
        this.editShopInfo.openTypes = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _getShopTypes() {
      try {
        const res = await getShopTypes({ page: 1, row: 100 })
        this.shopInfo.shopTypes = res.data
      } catch (error) {
        console.error('获取商铺类型失败:', error)
      }
    },
    handlePositionChange(position) {
      this.editShopInfo.mapX = position.lng
      this.editShopInfo.mapY = position.lat
    },
    handleUploadImage(param) {
      if (param.length > 0) {
        this.editShopInfo.shopLogo = param[param.length - 1]
      } else {
        this.editShopInfo.shopLogo = ''
      }
    },
    refreshEditShopInfo() {
      this.$refs.uploadImage.clearImages()
      this.editShopInfo = {
        shopId: '',
        shopName: '',
        applyOpinion: '',
        shopLogo: '2',
        storeId: '',
        changeLogo: '',
        shopType: '',
        openType: '',
        shopDesc: '',
        sendAddress: '',
        returnPerson: '',
        returnLink: '',
        returnAddress: '',
        shopRange: '',
        shopRangeSel: [],
        shopRanges: [],
        openTypes: [],
        mapX: '',
        mapY: '',
        state: '',
        areaCode: '',
        businessLicense: '',
        foodLicense: '',
        idCardFront: '',
        idCardBack: ''
      }
    },
    _changeEditShopType() {
      console.log(this.editShopInfo.shopRangeSel)
      this.editShopInfo.shopRangeSel = []
    },
    async editShop() {
      try {
        // 未缴纳保证金（状态004）禁止修改，提前拦截避免无效请求
        if (this.editShopInfo.state === '004') {
          this.$message.warning('当前店铺未缴纳保证金，请先缴纳保证金后再修改店铺信息。')
          return
        }
        const valid = await this.$refs.editShopForm.validate()
        if (!valid) return

        if (!this.editShopInfo.businessLicense) {
          this.$message.error('请上传营业执照')
          return
        }
        if (!this.editShopInfo.idCardFront) {
          this.$message.error('请上传身份证正面')
          return
        }
        if (!this.editShopInfo.idCardBack) {
          this.$message.error('请上传身份证反面')
          return
        }

        const phoneReg = /^1[3-9]\d{9}$/
        if (!phoneReg.test(this.editShopInfo.returnLink)) {
          this.$message.error('联系电话格式不正确，请输入11位手机号')
          return
        }

        const res = await updateShop(this.editShopInfo)
        if (res.code === 0) {
          this.dialogVisible = false
          this.$emit('listShop')
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>